<template>
  <v-switch
    color="blue darken-2"
    inset
    v-model="showInstallPrompt"
    @change="setInstall()"
    :label="`Show Install Prompt (If Previously Dismissed)`"
  ></v-switch>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "InstallPrompt",

  data() {
    return {
      showInstallPrompt: this.$store.getters.retrieveHomeScreenPrompt,
    };
  },

  computed: {},

  methods: {
    ...mapActions(["setHomeScreenPrompt"]),

    async setInstall() {
      console.log(" -- Setting Install Prompt");
      console.log(this.showInstallPrompt);
      await this.setHomeScreenPrompt(this.showInstallPrompt);
    },
  },
};
</script>

<style lang="sass" scoped>
</style>